<pbc-sorter [config]="ZeitenSorterConfig" [sorter]="zeiten.sorter$ | async" (sorterChange)="zeiten.sorter$.next($event)"></pbc-sorter>
